import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import moment from 'moment';
import { firstValueFrom } from 'rxjs';
import { Utility } from './utility';

export type LoadHistoryFilter = {
    loadDateStart?: Date;
    loadDateEnd?: Date;
    customerId?: number;
    productId?: number;
    ticketNumber?: number;
};

@Injectable({ providedIn: 'root' })
export class HistoryService {
    http = inject(HttpClient);

    async getLoadHistory(filter: LoadHistoryFilter) {
        filter.loadDateStart = Utility.startOfDay(filter.loadDateStart);
        filter.loadDateEnd = Utility.startOfDay(filter.loadDateEnd);
        return firstValueFrom(this.http.post<any[]>(`${environment.serviceName}/history/loadHistory`, filter));
    }

    async getInvoiceHistory(filter: any) {
        filter.invoiceDateStart = Utility.startOfDay(filter.invoiceDateStart);
        filter.invoiceDateEnd = Utility.startOfDay(filter.invoiceDateEnd);
        return firstValueFrom(this.http.post<any[]>(`${environment.serviceName}/history/invoiceHistory`, filter));
    }
    async getTicketTypes() {
        return firstValueFrom(this.http.get<{ value: number; name: string }[]>(`${environment.serviceName}/history/getTicketTypes`));
    }
}
